import React, { useState } from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import classes from 'components/common/PasswordInput/PasswordInput.module.scss';

import TextInput, { TextInputProps } from 'components/DesignSystem/TextInput/TextInput';

export const PasswordInput = React.forwardRef<HTMLInputElement, TextInputProps>(
    ({ value, onChange, className, ...rest }, ref) => {
        const [showPassword, setShowPassword] = useState<boolean>(false);

        return (
            <div className={classes.inputWrapper}>
                <TextInput
                    data-testid={'input'}
                    className={`${className || ''}`}
                    type={showPassword ? 'text' : 'password'}
                    value={value}
                    onChange={onChange}
                    clearable={false}
                    {...rest}
                    ref={ref}
                />
                <div className={classes.toggleIcon}>
                    <MuiIcon
                        icon={showPassword ? 'visibility_off' : 'visibility'}
                        onClick={() => setShowPassword(!showPassword)}
                        fontSize={'20px'}
                        role={'toggle-icon'}
                    />
                </div>
            </div>
        );
    },
);
